import React, { createContext, useContext, useState } from "react";

const CartContext = createContext();

export function useCart() {
  return useContext(CartContext);
}

export function CartProvider({ children }) {
  const [cart, setCart] = useState({});

  const addToCart = (productId, quantity = 1) => {
    setCart((prev) => {
      // Only allow one of each item in the cart
      if (prev[productId]) return prev;
      return {
        ...prev,
        [productId]: 1,
      };
    });
  };

  const removeFromCart = (productId) => {
    setCart((prev) => {
      const newCart = { ...prev };
      delete newCart[productId];
      return newCart;
    });
  };

  const updateCart = (productId, quantity) => {
    setCart((prev) => ({ ...prev, [productId]: quantity }));
  };

  const clearCart = () => setCart({});

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateCart, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}
